(function () {
    'use strict';

    /**
     * Match Liquid alt exclusion (strip + lowercase + NFC for robust Unicode).
     */
    function normalizeGalleryAlt(str) {
      if (str == null || str === '') {
        return '';
      }
      var s = String(str);
      try {
        return s.normalize('NFC').toLowerCase();
      } catch (e2) {
        return s.toLowerCase();
      }
    }

    function syncLbCaptionToImage(slideNode) {
      if (!slideNode) {
        return;
      }
      var desc = slideNode.querySelector('.gslide-description');
      var img =
        slideNode.querySelector('.gslide-image img') ||
        slideNode.querySelector('.gslide-media img');
      if (!desc || !img) {
        return;
      }

      function clearInline() {
        desc.style.width = '';
        desc.style.maxWidth = '';
        desc.style.marginLeft = '';
        desc.style.marginRight = '';
      }

      function markCaptionSettled() {
        document.body.classList.remove('dynamic-gallery-lb-syncing');
      }

      if (document.body.classList.contains('glightbox-mobile')) {
        clearInline();
        markCaptionSettled();
        return;
      }

      function apply() {
        if (document.body.classList.contains('glightbox-mobile')) {
          clearInline();
          markCaptionSettled();
          return;
        }
        var rect = img.getBoundingClientRect();
        var w = Math.round(rect.width || img.offsetWidth || 0);
        if (w < 24) {
          return;
        }
        desc.style.boxSizing = 'border-box';
        desc.style.width = w + 'px';
        desc.style.maxWidth = w + 'px';
        desc.style.marginLeft = 'auto';
        desc.style.marginRight = 'auto';
        markCaptionSettled();
      }

      apply();
      if (!img.complete) {
        img.addEventListener('load', apply, { once: true });
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(apply);
      });
    }

    var resizeCaptionBound = false;
    var resizeCaptionDebounced = null;

    function debounce(fn, ms) {
      var t = null;
      function wrapped() {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      }
      wrapped.cancel = function () { clearTimeout(t); };
      return wrapped;
    }

    function destroyGallery(sectionEl) {
      if (!sectionEl || !sectionEl.dataset) return;
      var id = sectionEl.dataset.sectionId;
      if (!id) return;

      if (sectionEl._galleryResizeListener && typeof sectionEl._galleryResizeListener.cancel === 'function') {
        sectionEl._galleryResizeListener.cancel();
      }

      if (sectionEl._galleryResizeWrapper) {
        window.removeEventListener('resize', sectionEl._galleryResizeWrapper);
        sectionEl._galleryResizeWrapper = null;
      }

      var grid = sectionEl.querySelector('#gallery-grid-' + id);
      if (grid) grid.classList.remove('dynamic-gallery__grid--packery-ready');

      if (sectionEl._galleryPackery) {
        try { sectionEl._galleryPackery.destroy(); } catch (e) {}
        sectionEl._galleryPackery = null;
      }

      if (sectionEl._observer) {
        sectionEl._observer.disconnect();
        sectionEl._observer = null;
      }

      if (sectionEl._dynamicGalleryAjaxNavHandler) {
        sectionEl.removeEventListener('click', sectionEl._dynamicGalleryAjaxNavHandler);
        sectionEl._dynamicGalleryAjaxNavHandler = null;
      }
    }

    function initGallery(sectionEl) {
      if (!sectionEl) return;

      destroyGallery(sectionEl);

      var sectionId = sectionEl.dataset.sectionId;
      var layoutMode = sectionEl.dataset.layout;
      var altKeywordRaw = (sectionEl.getAttribute('data-alt-keyword') || '').trim();
      var altKeywordNorm = normalizeGalleryAlt(altKeywordRaw);
      var blocklist = (sectionEl.dataset.blocklist || '')
        .split(',')
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(function (s) { return s.length > 0; });
      var captionCenter = sectionEl.dataset.captionCenter === 'true';
      var collectionAjax =
        sectionEl.dataset.collectionAjax === 'true' ||
        sectionEl.getAttribute('data-collection-ajax') === 'true';
      var sectionApiId = (sectionEl.getAttribute('data-section-api-id') || '').trim();
      var sectionFileSlug = (sectionEl.getAttribute('data-section-file-slug') || 'dynamic-product-gallery').trim();
      if (!sectionApiId) {
        sectionApiId = sectionFileSlug;
      }

      var grid = sectionEl.querySelector('#gallery-grid-' + sectionId);
      var emptyEl = sectionEl.querySelector('#gallery-empty-' + sectionId);
      var allItems = Array.from(sectionEl.querySelectorAll('.dynamic-gallery__item'));

      allItems = allItems.filter(function (item) {
        var img = item.querySelector('img');
        if (!img) { item.remove(); return false; }
        if (altKeywordNorm) {
          var altN = normalizeGalleryAlt(img.getAttribute('alt') || '');
          if (altN.indexOf(altKeywordNorm) !== -1) {
            item.remove();
            return false;
          }
        }
        var src = (img.getAttribute('src') || '').toLowerCase();
        for (var i = 0; i < blocklist.length; i++) {
          if (blocklist[i] && src.indexOf(blocklist[i]) !== -1) { item.remove(); return false; }
        }
        return true;
      });

      var seenSrcs = {};
      allItems = allItems.filter(function (item) {
        var img = item.querySelector('img');
        var src = img ? img.getAttribute('src') : null;
        if (!src || seenSrcs[src]) { if (item.parentNode) item.remove(); return false; }
        seenSrcs[src] = true;
        return true;
      });

      if (allItems.length === 0) {
        if (emptyEl) emptyEl.style.display = '';
        return;
      }

      var packeryInstance = null;

      sectionEl._galleryResizeListener = debounce(function () {
        var p = sectionEl._galleryPackery;
        if (layoutMode !== 'masonry' || !p) return;
        p.reloadItems();
        p.layout();
      }, 150);

      sectionEl._galleryResizeWrapper = function () {
        if (typeof sectionEl._galleryResizeListener === 'function') {
          sectionEl._galleryResizeListener();
        }
      };
      window.addEventListener('resize', sectionEl._galleryResizeWrapper);

      function initLayout() {
        if (!grid || layoutMode !== 'masonry' || typeof Packery === 'undefined') return;

        var hasTitles = !!(grid.querySelector('.dynamic-gallery__collection-title'));

        function doPackeryInit() {
          if (sectionEl._galleryPackery) {
            try { sectionEl._galleryPackery.destroy(); } catch (e) {}
            sectionEl._galleryPackery = null;
          }

          var opts = {
            itemSelector: '.dynamic-gallery__item',
            gutter: 8,
            percentPosition: true
          };

          var sizer = grid.querySelector('.dynamic-gallery__sizer');
          if (sizer) opts.columnWidth = sizer;
          if (hasTitles) opts.stamp = '.dynamic-gallery__collection-title';

          packeryInstance = new Packery(grid, opts);
          sectionEl._galleryPackery = packeryInstance;
          grid.classList.add('dynamic-gallery__grid--packery-ready');
          packeryInstance.layout();
          requestAnimationFrame(function () {
            packeryInstance.reloadItems();
            packeryInstance.layout();
          });
        }

        if (typeof imagesLoaded !== 'undefined') {
          imagesLoaded(grid, doPackeryInit);
        } else {
          doPackeryInit();
        }
      }

      initLayout();

      var lightboxInstance = null;

      function initLightbox() {
        function tryInit() {
          if (typeof GLightbox === 'undefined') return;
          if (lightboxInstance) {
            try { lightboxInstance.destroy(); } catch (e) {}
            lightboxInstance = null;
          }
          var lbOpts = {
            selector: '#gallery-grid-' + sectionId + ' .dynamic-gallery__item .glightbox',
            touchNavigation: true,
            loop: true,
            descPosition: 'bottom'
          };

          lightboxInstance = GLightbox(lbOpts);

          if (lightboxInstance.on) {
            lightboxInstance.on('open', function () {
              document.body.classList.add('dynamic-gallery-lb-active');
              document.body.classList.add('dynamic-gallery-lb-syncing');
              if (captionCenter) document.body.classList.add('dynamic-gallery-lb-caption-center');

              if (!resizeCaptionBound) {
                resizeCaptionDebounced = debounce(function () {
                  if (
                    !document.body.classList.contains('dynamic-gallery-lb-active') ||
                    document.body.classList.contains('glightbox-mobile')
                  ) {
                    return;
                  }
                  var node =
                    document.querySelector('.glightbox-container .gslide.current') ||
                    document.querySelector('.glightbox-container .gslide.in');
                  syncLbCaptionToImage(node);
                }, 150);
                window.addEventListener('resize', resizeCaptionDebounced);
                resizeCaptionBound = true;
              }

              window.requestAnimationFrame(function () {
                var cur =
                  typeof lightboxInstance.getActiveSlide === 'function'
                    ? lightboxInstance.getActiveSlide()
                    : document.querySelector('.glightbox-container .gslide.current');
                syncLbCaptionToImage(cur);
              });
            });

            lightboxInstance.on('slide_changed', function (evt) {
              var cur =
                evt && evt.current && evt.current.slideNode
                  ? evt.current.slideNode
                  : typeof lightboxInstance.getActiveSlide === 'function'
                    ? lightboxInstance.getActiveSlide()
                    : null;
              syncLbCaptionToImage(cur);
            });

            lightboxInstance.on('close', function () {
              document.body.classList.remove('dynamic-gallery-lb-active');
              document.body.classList.remove('dynamic-gallery-lb-caption-center');
              document.body.classList.remove('dynamic-gallery-lb-syncing');
            });
          }
        }

        if (window._glightboxReady) {
          tryInit();
        } else {
          document.addEventListener('glightbox:ready', tryInit, { once: true });
        }
      }

      initLightbox();

      if (collectionAjax) {
        if (sectionEl._dynamicGalleryAjaxNavHandler) {
          sectionEl.removeEventListener('click', sectionEl._dynamicGalleryAjaxNavHandler);
        }
        sectionEl._dynamicGalleryAjaxNavHandler = function (e) {
          var a = e.target.closest('a[href]');
          if (!a) return;
          var nav = a.closest('[data-dynamic-gallery-ajax-nav]');
          if (!nav || !sectionEl.contains(nav)) return;
          e.preventDefault();
          var href = a.getAttribute('href');
          if (!href || href === '#' || href.indexOf('javascript:') === 0) return;

          var shopifyWrap = sectionEl.closest('[id^="shopify-section-"]');
          if (shopifyWrap) shopifyWrap.classList.add('dynamic-gallery--loading');

          var domSectionId = '';
          if (shopifyWrap && shopifyWrap.id && shopifyWrap.id.indexOf('shopify-section-') === 0) {
            domSectionId = shopifyWrap.id.replace(/^shopify-section-/, '');
          }

          var paginationUrl;
          try {
            paginationUrl = new URL(href, window.location.href);
          } catch (err1) {
            if (shopifyWrap) shopifyWrap.classList.remove('dynamic-gallery--loading');
            return;
          }

          /**
           * Keep the CURRENT page path (template where this section exists). Pagination links
           * sometimes point at a collection URL; requesting sections there returns null.
           */
          var mergedUrl = new URL(window.location.href);
          paginationUrl.searchParams.forEach(function (value, key) {
            mergedUrl.searchParams.set(key, value);
          });

          function pickHtmlFromSectionsJson(json) {
            if (!json || typeof json !== 'object') {
              return null;
            }
            var candidates = [domSectionId, sectionApiId, sectionFileSlug].filter(function (x) {
              return x && String(x).length > 0;
            });
            var i;
            var k;
            var html = null;
            for (i = 0; i < candidates.length; i++) {
              k = candidates[i];
              if (json[k] && typeof json[k] === 'string') {
                return json[k];
              }
            }
            for (k in json) {
              if (!json.hasOwnProperty(k)) continue;
              if (json[k] && typeof json[k] === 'string' && json[k].indexOf('dynamic-gallery-section') !== -1) {
                return json[k];
              }
            }
            for (k in json) {
              if (!json.hasOwnProperty(k)) continue;
              if (json[k] && typeof json[k] === 'string') {
                return json[k];
              }
            }
            return null;
          }

          function fetchSectionsJson(urlStr) {
            return fetch(urlStr, {
              headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin'
            }).then(function (res) {
              if (!res.ok) throw new Error('HTTP ' + res.status);
              return res.json();
            });
          }

          function fetchSectionIdHtml(urlBase) {
            var sid = domSectionId || sectionApiId || sectionFileSlug;
            var u = new URL(urlBase.toString());
            u.searchParams.delete('sections');
            u.searchParams.set('section_id', sid);
            return fetch(u.toString(), {
              headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin'
            }).then(function (res) {
              if (!res.ok) throw new Error('section_id HTTP ' + res.status);
              return res.text();
            });
          }

          mergedUrl.searchParams.set('sections', domSectionId || sectionApiId || sectionFileSlug);

          fetchSectionsJson(mergedUrl.toString())
            .then(function (json) {
              var html = pickHtmlFromSectionsJson(json);
              if (html) {
                return html;
              }
              mergedUrl.searchParams.set('sections', sectionFileSlug);
              return fetchSectionsJson(mergedUrl.toString()).then(function (json2) {
                var h = pickHtmlFromSectionsJson(json2);
                if (h) return h;
                return fetchSectionIdHtml(mergedUrl);
              });
            })
            .then(function (html) {
              if (!html || typeof html !== 'string') {
                throw new Error('No section HTML (template may not include this section on the fetched URL)');
              }
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var incoming = doc.querySelector('[id^="shopify-section-"]');
              var reusedWrapper = false;
              if (!incoming) {
                var tmp = document.createElement('div');
                tmp.innerHTML = html.trim();
                incoming = tmp.querySelector('[id^="shopify-section-"]');
              }
              if (!incoming && shopifyWrap) {
                var tmpFrag = document.createElement('div');
                tmpFrag.innerHTML = html.trim();
                var dgOnly = tmpFrag.querySelector('.dynamic-gallery-section');
                if (dgOnly) {
                  shopifyWrap.innerHTML = '';
                  shopifyWrap.appendChild(dgOnly.cloneNode(true));
                  incoming = shopifyWrap;
                  reusedWrapper = true;
                }
              }
              if (!incoming || (!reusedWrapper && !shopifyWrap.parentNode)) {
                throw new Error('Parse error');
              }
              if (!reusedWrapper && shopifyWrap.parentNode) {
                shopifyWrap.parentNode.replaceChild(incoming, shopifyWrap);
              }
              incoming.classList.remove('dynamic-gallery--loading');
              var fresh = incoming.querySelector('.dynamic-gallery-section');
              if (fresh) {
                initGallery(fresh);
                [120, 350, 700].forEach(function (delayMs) {
                  setTimeout(function () {
                    var p = fresh._galleryPackery;
                    if (p && fresh.dataset.layout === 'masonry') {
                      try {
                        p.reloadItems();
                        p.layout();
                      } catch (eR) {}
                    }
                    try {
                      window.dispatchEvent(new Event('resize'));
                    } catch (eZ) {}
                  }, delayMs);
                });
              }
              try {
                var hist = new URL(window.location.href);
                paginationUrl.searchParams.forEach(function (v, key) {
                  hist.searchParams.set(key, v);
                });
                if (window.history && window.history.pushState) {
                  window.history.pushState({}, '', hist.pathname + hist.search);
                }
              } catch (e3) {}
              try {
                incoming.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } catch (e4) {}
            })
            .catch(function (err) {
              if (typeof console !== 'undefined' && console.error) {
                console.error('[dynamic-gallery] AJAX pagination failed', err);
              }
              if (shopifyWrap) shopifyWrap.classList.remove('dynamic-gallery--loading');
            });
        };
        sectionEl.addEventListener('click', sectionEl._dynamicGalleryAjaxNavHandler);
      }
    }

    function boot() {
      document.querySelectorAll('.dynamic-gallery-section').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.dynamic-gallery-section');
      if (el) initGallery(el);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('.dynamic-gallery-section');
      if (el) destroyGallery(el);
      document.body.classList.remove('dynamic-gallery-lb-caption-center');
      document.body.classList.remove('dynamic-gallery-lb-active');
    });
  })();
